import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { EmptyRequestState, RequestState } from "../../../../models/RequestState";
import { DeleteClassroom } from "../../../../store/ClassroomAdmin/ClassroomToolsAction";
import { RootState } from "../../../../store/store";
import StatusCode from "../../../../util/StatusCode";
import Loading from "../../../misc/Loading";
import { CoreClassroomAdminClassroom } from "../../../../models/CoreClassroomAdminClassroom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const ClassroomViewToolDeleteClassroom = () => {
    const { t } = useTranslation(['common', "classroomAdmin"]);
    const dispatch = useDispatch();

    const [confirm, setConfirm] = useState<boolean>(false);
    const deleteClassroomState = useSelector<RootState, EmptyRequestState>(x => x.classroomTools.deleteClassroom);
    const classroom = useSelector<RootState, RequestState<CoreClassroomAdminClassroom>>(x => x.classroomAdminClassroom.classroom);

    const deleteClassroom = () => {
        setConfirm(true);
        if (classroom.code === StatusCode.COMPLETE && classroom.data) {
            DeleteClassroom(classroom.data.classroomId)(dispatch);
        };
    };

    if (!confirm) {
        return (
            <div>
                <p>{t(`tools.DELETE_CLASSROOM.confirmText`, { ns: 'classroomAdmin' })}</p>
                <Button onClick={() => deleteClassroom()}>{t('yes', { ns: 'common' })}</Button>
            </div>
        )
    }
    if (deleteClassroomState.code === StatusCode.PENDING) {
        return <Loading />;
    }
    if (deleteClassroomState.code === StatusCode.ERROR) {
        const errorData = deleteClassroomState.error.response?.data as { title?: string; detail?: string } | undefined;
        const title = errorData?.title;
        const errorMessage = title ? t(`tools.errors.general.${title}`, { ns: 'classroomAdmin' }) : t(`error.somethingWentWrong`, { ns: 'common' });
        return (<>
            <FontAwesomeIcon icon="triangle-exclamation" color="red" style={{ marginRight: '5px' }} />
            {errorMessage}
        </>);
    }
    if (deleteClassroomState.code === StatusCode.COMPLETE) {
        return (<>
            <FontAwesomeIcon icon="check" color="green" style={{ marginRight: '5px' }} />
            {t(`tools.DELETE_CLASSROOM.success`, { ns: 'classroomAdmin' })}
        </>);
    }
}

export default ClassroomViewToolDeleteClassroom;
